import { Location } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { LocalizeParser, LocalizeRouterModule, LocalizeRouterSettings, ManualParserLoader } from '@gilsdav/ngx-translate-router';
// import { TranslateService } from '@ngx-translate/core';

// export function HttpLoaderFactory(translate: TranslateService, location: Location, settings: LocalizeRouterSettings) {
//   return new ManualParserLoader(translate, location, settings, ['en']);
// }

const routes: Routes = [
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: 'main'
  // },
  {
    path: '',
    loadChildren: () => import('./views/main/main.module').then(m => m.MainModule)
  }
  // {
  //   path: 'monitor',
  //   loadChildren: () => import('./views/monitor/monitor.module').then(m => m.MonitorModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    // LocalizeRouterModule.forRoot(routes, {
    //   parser: {
    //     provide: LocalizeParser,
    //     useFactory: HttpLoaderFactory,
    //     deps: [TranslateService, Location, LocalizeRouterSettings]
    //   }
    // })
  ],
  exports: [
    RouterModule,
    // LocalizeRouterModule
  ]
})
export class AppRoutingModule { }
